import { Link } from "react-router-dom";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-leaf-fill text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading font-extrabold text-lg text-background-50">激情丛林</span>
          </div>
          <p className="text-sm leading-relaxed text-primary-200">
            专注“激情丛林”系列电视剧及同类型影视内容的高清在线观看与介绍，让每一次观看都轻松顺畅。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold text-background-50 mb-4 tracking-wide">快速导航</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/" className="text-primary-200 hover:text-accent-300 transition-colors">
                首页
              </Link>
            </li>
            <li>
              <Link to="/category/tv" className="text-primary-200 hover:text-accent-300 transition-colors">
                电视剧
              </Link>
            </li>
            <li>
              <Link to="/category/movie" className="text-primary-200 hover:text-accent-300 transition-colors">
                电影
              </Link>
            </li>
            <li>
              <Link to="/category/hot" className="text-primary-200 hover:text-accent-300 transition-colors">
                热门推荐
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-background-50 mb-4 tracking-wide">帮助与支持</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/about" className="text-primary-200 hover:text-accent-300 transition-colors">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/search" className="text-primary-200 hover:text-accent-300 transition-colors">
                搜索影视
              </Link>
            </li>
            <li>
              <a href="mailto:support@jingqi-conglin.example" className="text-primary-200 hover:text-accent-300 transition-colors">
                意见反馈
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-background-50 mb-4 tracking-wide">友情链接</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <a href="mailto:partner@jingqi-conglin.example" className="text-primary-200 hover:text-accent-300 transition-colors">
                内容合作
              </a>
            </li>
            <li>
              <a href="mailto:support@jingqi-conglin.example" className="text-primary-200 hover:text-accent-300 transition-colors">
                版权声明
              </a>
            </li>
            <li>
              <a href="mailto:support@jingqi-conglin.example" className="text-primary-200 hover:text-accent-300 transition-colors">
                隐私条款
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800 px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-primary-300">
          © {year} 激情丛林 影视内容站 · 本站所有影视内容均为前端演示数据
        </p>
        <p className="text-xs text-primary-300">
          仅供学习与演示使用 · 不提供任何真实影视资源下载或播放
        </p>
      </div>
    </footer>
  );
}